export const canRefundOrder = (order) => {
  if (order.amount_refund < order.amount) {
    return true;
  }
  return false;
}
